import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Product from './pages/Product';
import AddProduct from './pages/AddProductPage';
import Blogs from './pages/Blogs';
import AddBlog from './pages/AddBlogPage';
import AddPlan from './pages/AddPlanPage';
import Videos from './pages/Videos';
import AddVideo from './pages/AddVideoPage';
import Services from './pages/Services';
import Users from './pages/Users';
import Plans from './pages/Plans';
import Order from './pages/Order';
import Providers from './pages/Providers';
import Subscriptions from './pages/Subscriptions';
import Appointments from './pages/Appointments';
import Billing from './pages/Billings';
import MentalHealthVideos from './pages/MentalHealthVideos';
import LabServiceManagement from './pages/LabServiceManagement';
import Alltransaction from './pages/Alltransaction';


// Function to check if the user is authenticated
const isAuthenticated = () => !!localStorage.getItem('token');

// Protected Route Component
const ProtectedRoute = ({ element: Component, ...rest }) => {
  return isAuthenticated() ? <Component {...rest} /> : <Navigate to="/login" replace />;
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login />} />

        <Route path="/dashboard" element={<ProtectedRoute element={Dashboard} />} />
        <Route path="/products" element={<ProtectedRoute element={Product} />} />
        <Route path="/add-product" element={<ProtectedRoute element={AddProduct} />} />
        <Route path="/blogs" element={<ProtectedRoute element={Blogs} />} />
        <Route path="/add-blog" element={<ProtectedRoute element={AddBlog} />} />
        <Route path="/videos" element={<ProtectedRoute element={Videos} />} />
        <Route path="/add-video" element={<ProtectedRoute element={AddVideo} />} />
        <Route path="/services" element={<ProtectedRoute element={Services} />} />
        <Route path="/users" element={<ProtectedRoute element={Users} />} />
        <Route path="/plans" element={<ProtectedRoute element={Plans} />} />
        <Route path="/provider-list" element={<ProtectedRoute element={Providers} />} />
        <Route path="/add-plan" element={<ProtectedRoute element={AddPlan} />} />
        <Route path="/orders" element={<ProtectedRoute element={Order} />} />
        <Route path="/subscriptions" element={<ProtectedRoute element={Subscriptions} />} />
        <Route path="/appointments" element={<ProtectedRoute element={Appointments} />} />
        <Route path="/billings" element={<ProtectedRoute element={Billing} />} />
        <Route path="/MentalHealthVideos" element={<ProtectedRoute element={MentalHealthVideos} />} />
        <Route path="/LabServiceManagement" element={<ProtectedRoute element={LabServiceManagement} />} />
         <Route path="/alltransaction" element={<ProtectedRoute element={Alltransaction} />} />
      </Routes>
    </Router>
  );
}
export default App;
